import * as api from './api';
import { supabase } from '../supabaseClient';
import { getOrgId } from './orgStore';

const TABLE = 'tax';
const PK = 'tax_id';

/**
 * Fetch the tax codes visible to the current org: its own private codes
 * plus the shared global codes (is_global = true).
 *
 * Shared by every screen that lists tax rates (Tax Codes view, Item modal,
 * and the invoice/quote/bill/purchase modals via their own services).
 */
export const fetchTaxes = async () => {
  const orgId = getOrgId();
  if (!orgId) throw new Error('No org selected (org_id is null).');

  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .or(`org_id.eq.${orgId},is_global.eq.true`);
  if (error) throw error;
  return data || [];
};

/** Tax IDs (e.g. "GST") are user-provided. */
export const createTax = (data) => {
  if (!data[PK]) throw new Error('Please provide a Tax Code / ID.');
  return api.createRecord(TABLE, data);
};

export const updateTax = (id, data) =>
  api.updateRecord(TABLE, PK, id, data);

export const deleteTax = (id) =>
  api.deleteRecord(TABLE, PK, id);
